import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IAuthTokenModel } from '../logic/auth/models/auth-token.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _user$ = new BehaviorSubject<any | null>(null);
  private _userIsAuth$ = new BehaviorSubject<boolean>(false);
  private _userIsAuthenticated$ = new BehaviorSubject<IAuthTokenModel | null>(
    null,
  );

  constructor() {
    this.syncAuthFromStorage();
  }

  get userIsAuthenticated$() {
    this.syncAuthFromStorage();
    return this._userIsAuthenticated$.asObservable();
  }

  get user() {
    return this._user$.asObservable();
  }

  set currentUser(current: any) {
    this._user$.next(current);
  }

  login(token: IAuthTokenModel | null) {
    const nextToken = this.normalizeToken(token?.token);
    const currentToken = this.normalizeToken(
      this._userIsAuthenticated$.value?.token,
    );
    if (nextToken === currentToken) {
      return;
    }
    this._userIsAuth$.next(!!nextToken);
    this._userIsAuthenticated$.next(nextToken ? { token: nextToken } : null);
  }

  logout() {
    this._userIsAuth$.next(false);
    this._userIsAuthenticated$.next(null);
  }

  isAuthenticated(): boolean {
    return !!this.normalizeToken(localStorage.getItem('token'));
  }

  private syncAuthFromStorage(): void {
    const token = this.normalizeToken(localStorage.getItem('token'));
    this.login(token ? { token } : null);
  }

  private normalizeToken(token: string | null | undefined): string | null {
    if (!token || token === 'null' || token === 'undefined') {
      return null;
    }
    return token;
  }
}
